import { useEffect, useState } from 'react';

import { Loading } from '@ui-core';

export const ProgressBar = () => {
  const [percentage, setPercentage] = useState(10);

  useEffect(() => {
    const interval = setInterval(() => {
      if (percentage === 100) {
        clearInterval(interval);
      } else {
        setPercentage(percentage + 5);
      }
    }, 100);

    return () => clearInterval(interval);
  }, [percentage]);

  return (
    <div className="h-dvh flex-1">
      <div className="absolute start-0 top-px z-50 w-full">
        <div
          className="h-0.5 rounded bg-gradient-to-r from-primary-300 to-primary transition-[width] duration-500"
          style={{ width: `${percentage}%` }}
        />
      </div>
      <div className="flex h-dvh w-full flex-1 justify-center">
        <Loading />
      </div>
    </div>
  );
};
